import { css } from "emotion";
import { Component } from "preact";
import React from "react";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import H4 from "../../../components/global/H4";
import P from "../../../components/global/P";
import Image from "../../../components/Image";
import ContentBlock from "../../../components/layout/ContentBlock";
import Layout from "../../../components/layout/Layout";
import { updateTitle } from "../../../utils/BrowserUtils";
import FAQS from "../FAQS";
import BuyerForm from "../forms/BuyerForm";

const emailIcon = require("../../../assets/ic_email_form.svg");

const wrapper = css({
  textAlign: "center",
  maxWidth: 700,
  margin: "0 auto",
  h2: {
    marginBottom: 16
  },
  p: {
    marginBottom: 40
  },
  padding: "0 14px"
});

const heading = css({
  display: "flex",
  alignItems: "center",
  marginBottom: 24,
  textAlign: "left",
  img: {
    marginRight: 12
  },
  "@media(max-width: 600px)": {
    alignItems: "end"
  }
});

const faqs = [
  {
    link:
      "https://humanitix.helpdocs.io/article/zcaqh6asa5-i-can-t-find-my-tickets",
    text: "I can't find my tickets/invoice"
  },
  {
    link: "https://humanitix.helpdocs.io/article/c43m3gy4v6-request-a-refund",
    text: "I want a refund"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/syk7av75zr-i-want-to-change-my-booking",
    text: "I want to change my booking (to a different time/location/session)"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/8si0f5n7z2-how-do-i-update-and-edit-my-order-information",
    text: "I want to edit my order details (i.e. names on tickets)"
  }
];

class BuyerSupport extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    updateTitle("Customer Support");
  }

  render() {
    const { locale } = this.props;
    return (
      <Layout>
        <ContentBlock color="grey" sidePad={false}>
          <div className={wrapper}>
            <H2>Buyer Support</H2>
            <P>
              Maybe you can find an answer to your question in our FAQs, if that
              doesn’t work for you, send an enquiry to our human 🙂{" "}
            </P>
            <FAQS faqs={faqs} />
            <div className={heading}>
              <Image imageURL={emailIcon} alt="Email Icon" />
              <H4>
                Submit an enquiry and our support team will be in touch shortly
              </H4>
            </div>
            <BuyerForm locale={locale} />
          </div>
        </ContentBlock>
      </Layout>
    );
  }
}

export default CMSComponent(null, BuyerSupport, 400);
